import type { IconData } from '@stacksjs/iconify-core'

export const rainbow: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10h-2a8 8 0 1 0-16 0zm4 0a6 6 0 1 1 12 0h-2a4 4 0 1 0-8 0zm4 0a2 2 0 1 1 4 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default rainbow
